import get from 'lodash.get';
import {
    FETCH_PDF_AVAILABILITY,
    UPLOAD_PDF_AVAILABILITY,
} from '../../actionTypes/shared/apiActionTypes';

export const initialState = {
    pdfAvailabilityConfig: {},
    error: null,
};

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case UPLOAD_PDF_AVAILABILITY.SUCCESS:
            return {
                ...state,
                pdfAvailabilityConfig: {
                    pdfAvailability: action.additionalResponseParams,
                    pdfAvailability_bk: action.response?.pdfAvailability_bk,
                },
            };
        case FETCH_PDF_AVAILABILITY.SUCCESS:
            return {
                ...state,
                pdfAvailabilityConfig: { ...action.response },
            };
        case UPLOAD_PDF_AVAILABILITY.ERROR:
        case FETCH_PDF_AVAILABILITY.ERROR:
            return {
                ...state,
                pdfAvailabilityConfig: {},
                error: action.error,
            };
        default:
            return state;
    }
};

const getPdfAvailability = state => get(state, 'pdfAvailabilityConfig');

export const selectors = {
    getPdfAvailability,
};
